import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/article/comments.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/article/hearts.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/community/heart.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/public/images/searchresults/icon_location-pin.svg");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/app/[locale]/page-view-event.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/footer/footer.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/layout/layout/main/main.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/links/links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/logo/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/profile/profile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/components/layout/layout/navbar/wrapper/wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/blogs/hero/categories-picker/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/categories-picker/categories-loader.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/categories-picker/categories-picker.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/post-comments-and-likes/label.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/post-comments-and-likes/post-comments-and-likes.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/categories-picker/categories.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/post-card/header.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/post-card/post-card.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/hero.module.scss");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/components/skeleton/skeleton.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/blogs/hero/search/search.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/hero/title.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/clients/web/packages/website/src/modules/blogs/post-list/post-list.tsx");
;
import(/* webpackMode: "eager" */ "/src/clients/web/packages/website/src/modules/blogs/post-list/posts-grid.module.scss");
